import { render } from "./ios2.vue?vue&type=template&id=744d356f&scoped=true&ts=true"
import script from "./ios2.vue?vue&type=script&lang=ts"
export * from "./ios2.vue?vue&type=script&lang=ts"

import "./ios2.vue?vue&type=style&index=0&id=744d356f&scoped=true&lang=scss"

import exportComponent from "D:\\project\\H5-NEW\\H5\\APP内嵌H5\\rs-h5app\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-744d356f"]])

export default __exports__